import { Box, Button, LinearProgress, Stack } from "@mui/material";
import React from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ATTACH_FILE_TO_PET_AND_APP } from "../../../enums/ApiPaths";
import { APPOINTMENT_FILES } from "../../../enums/QueryKeys";
import { FileUploadContext } from "../../../features/appointments/context/ToggleFileUpload";
import ConfirmAndCancelButtons, {
  cancelButtonVariant,
} from "../../buttons/ConfirmAndCancelButtons";
import SimpleAlert from "../../display/SimpleAlert";
import FileUploadEditing from "./FileUploadEditing";
import usePutAppointmentFiles from "./hooks/usePutAppointmentFiles";
import { useParams } from "react-router-dom";
import { useGetCategoreisOverAppointment } from "./hooks/useGetCategoreis";

export const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      resolve(reader.result.split(",")[1]);
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
};

export default function FileUploadEditingForm({
  files,
  back,
  endpoint = null,
}) {
  const { t } = useTranslation();
  const { id: appointmentId } = useParams();

  const context = React.useContext(FileUploadContext);
  const feedbackMessage = React.useRef(
    "UploadingYourFilesThisMightTakeAWhileMultiple",
  );
  const categories = useGetCategoreisOverAppointment(appointmentId);

  const url = endpoint || ATTACH_FILE_TO_PET_AND_APP + appointmentId;
  const { loading, submitCallback, res } = usePutAppointmentFiles(
    url,
    APPOINTMENT_FILES + appointmentId,
  );

  const methods = useForm();

  const handleSubmit = async (data) => {
    const submitData = await Promise.all(
      data?.files?.map(async (fileData, index) => {
        const file = files[index - 1];
        if (file) {
          var base64File = await fileToBase64(file);
          const fileExtension = file.name.split(".").pop();
          const inputedTitle =
            fileData?.title?.split(".").slice(0, -1).join(".") ||
            fileData?.title;
          const fileTitleWithExtension = fileData?.title
            ? `${inputedTitle}.${fileExtension}`
            : file.name;
          return {
            file: base64File,
            fileTitle: fileTitleWithExtension,
            documentCategory: fileData?.category || null,
          };
        }
      }),
    );

    //For some reason getting null or undefined data in array so removing that
    const filteredData = submitData.filter(
      (item) => item !== undefined && item !== null,
    );

    if (filteredData.length == 1) {
      feedbackMessage.current = "UploadingYourFilesThisMightTakeAWhile";
    }
    
    const res = await submitCallback(filteredData);

    if (res) {
      context.close();
    }
  };

  if (loading) {
    return (
      <Stack spacing={2}>
        <Stack>
          <SimpleAlert severity={"info"} message={feedbackMessage.current} />
          <LinearProgress />
        </Stack>
        <Box display={"flex"} justifyContent={"flex-end"}>
          <Button
            onClick={() => context.close()}
            variant={cancelButtonVariant}
            color="error"
          >
            {t("Close")}
          </Button>
        </Box>
      </Stack>
    );
  }
  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(handleSubmit)}>
        {files?.map((file, index) => (
          <FileUploadEditing categories={categories} key={index} file={file} index={index + 1} />
        ))}
        <ConfirmAndCancelButtons
          confirmTitle="Save"
          cancelTitle="Back"
          onCancel={() => back()}
          isConfirmLoading={categories.error && !categories.isLoading}
        />
      </form>
    </FormProvider>
  );
}
